module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-01.c7c7efab.jpg";